import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum ContractStatusIds {
  NO_SERVICES = 1,
  DRAFT,
  SIGNED,
  IN_REVIEW,
  READY_FOR_SUBMISSION,
  SUBMITTED,
  ACCEPTED,
  EXPIRED,
}

export function getContractStatii(): ISelectItem[] {
  return [
    {
      id: ContractStatusIds.NO_SERVICES,
      label: 'No Services',
      disabled: true,
    },
    { id: ContractStatusIds.DRAFT, label: 'Draft', disabled: true },
    { id: ContractStatusIds.SIGNED, label: 'Signed', disabled: true },
    { id: ContractStatusIds.IN_REVIEW, label: 'In Review', disabled: true },
    {
      id: ContractStatusIds.READY_FOR_SUBMISSION,
      label: 'Ready to Submit',
      disabled: true,
    },
    { id: ContractStatusIds.SUBMITTED, label: 'Submitted', disabled: true },
    { id: ContractStatusIds.ACCEPTED, label: 'Accepted', disabled: true },
    { id: ContractStatusIds.EXPIRED, label: 'Expired', disabled: false },
  ]
}

export const getContractStatusByLabel = getItemByLabelFactory(getContractStatii)
export const getContractStatusById = getItemByIdFactory(getContractStatii)
